import '../themeDefaults';

export default ({ datepickerReact }) => ({
  option: {
    '&:focus': {
      outlineColor: datepickerReact.focusColor,
    },
    '&:hover': {
      background: datepickerReact.rangePanelHover,
    },
    background: 'transparent',
    border: 0,
    color: datepickerReact.text,
    cursor: 'pointer',
    display: 'block',
    fontFamily: datepickerReact.fontFamily,
    fontSize: 14,
    lineHeight: '16px',
    padding: [8, 14],
    textAlign: 'left',
    width: '100%',
  },
  root: {
    padding: [10, 0],
  },
  selected: {
    '&:hover': {
      background: datepickerReact.selected,
    },
    background: datepickerReact.selected,
    color: datepickerReact.selectedText,
  },
});
